import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChatCircleDots } from "@phosphor-icons/react";
import { LiveBadge } from "./LiveBadge";
import { TWITCH_CHANNEL } from "../config/socials";

export const LiveStream = () => {
    const [parent, setParent] = useState("localhost");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setParent(window.location.hostname);
        }
    }, []);

    return (
        <section className="relative py-10 lg:py-14" data-testid="live-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="flex items-center gap-3 mb-6"
                >
                    <LiveBadge />
                    <span className="text-white/30 text-sm">·</span>
                    <span className="eyebrow">twitch.tv/{TWITCH_CHANNEL}</span>
                </motion.div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                    {/* Player */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.05 }}
                        className="lg:col-span-2 relative rounded-2xl overflow-hidden border border-white/10 bg-black"
                        data-testid="twitch-player-wrapper"
                    >
                        <div className="aspect-video bg-black">
                            <iframe
                                src={`https://player.twitch.tv/?channel=${TWITCH_CHANNEL}&parent=${parent}&parent=localhost&autoplay=false&muted=true`}
                                allowFullScreen
                                title="itz_ool live stream"
                                className="w-full h-full"
                                data-testid="twitch-player-iframe"
                            />
                        </div>
                    </motion.div>

                    {/* Chat */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className="relative rounded-2xl overflow-hidden border border-white/10 bg-obsidian-900 flex flex-col"
                        data-testid="twitch-chat-wrapper"
                    >
                        <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/10 bg-black/50">
                            <div className="flex items-center gap-2">
                                <ChatCircleDots size={14} className="text-brand-cyan" weight="fill" />
                                <span className="text-xs font-medium text-white/80">Chat</span>
                            </div>
                            <span className="text-[10px] uppercase tracking-wider text-white/40 font-mono">#{TWITCH_CHANNEL}</span>
                        </div>
                        <div className="flex-1 min-h-[420px]">
                            <iframe
                                src={`https://www.twitch.tv/embed/${TWITCH_CHANNEL}/chat?parent=${parent}&parent=localhost&darkpopout`}
                                title="itz_ool chat"
                                className="w-full h-full min-h-[420px]"
                                data-testid="twitch-chat-iframe"
                            />
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
